import { createCrudActions } from "../utils/crudGenerator";

const formatDecks = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.deckName}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchDecks,
  create: createDeck,
  update: updateDeck,
  delete: deleteDecks,
} = createCrudActions("DECK", "Deck", formatDecks);
